// OAuth Client IDs for Social Login
// Replace with your actual client IDs

export const webClientId = "your-google-client-id.apps.googleusercontent.com";

const ClientId = {
  google: webClientId,
  facebook: "your-facebook-app-id",
  apple: "your-apple-service-id"
};

export default ClientId;
